import Raven from 'raven-js';
import { inDevelopment } from '../lib/utils';

const decideConfigFile = () =>
  inDevelopment() || process.env.REACT_APP_PLATFORM_ENV === 'staging'
    ? require('./config.development')
    : require('./config.production');

// build configs
const {
  REACT_APP_API_ENDPOINT: ENDPOINT,
  REACT_APP_ASSET_URL: ASSETS_URL,
  REACT_APP_FIREBASE_AUTH_DOMAIN: authDomain,
  REACT_APP_FIREBASE_DATABASE_URL: databaseURL,
  REACT_APP_FIREBASE_PROJECT_ID: projectId,
  REACT_APP_FIREBASE_STORAGE_BUCKET: storageBucket,
  REACT_APP_TAWK_ID: tawkId,
} = decideConfigFile();

// runtime configs which is placed in the server according to environment
// and is copied to .env at runtime
const {
  REACT_APP_URL: appUrl,
  REACT_APP_FIREBASE_API_KEY: apiKey,
  REACT_APP_FIREBASE_PUBLIC_VAPID_KEY: PUBLIC_VAPID_KEY,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: messagingSenderId,
  REACT_APP_FACEBOOK: facebook,
  REACT_APP_FACEBOOK_ID: facebookPageId,
  REACT_APP_GOOGLE: google,
  REACT_APP_SENTRY: sentry,
  REACT_APP_GOOGLE_ANALYTICS: googleAnalytics,
  REACT_APP_STRIPE_KEY: stripe,
  REACT_APP_PAYPAL_ID: paypalId,
} = process.env;


const FIREBASE_CONFIG = {
  apiKey,
  authDomain,
  databaseURL,
  projectId,
  storageBucket,
  messagingSenderId,
};

const config = {
  ENDPOINT,
  ASSETS_URL,
  RESOURCE_URL: `${ENDPOINT}/static`,
  facebook,
  facebookPageId,
  FIREBASE_CONFIG,
  google,
  googleAnalytics,
  stripe,
  sentry,
  PUBLIC_VAPID_KEY,
  appUrl,
  tawkId,
  paypalId,
  honeyguidePhoneNumber: '+977-9803759639',
  honeyguideSupportPhoneNumber: '+977-9810102745',
  honeyguideEmail: 'busybee@honeyguideapps.com',
  honeyguideSupportEmail: 'honeybird@honeyguideapps.com',
  summitPhoneNumbers: ['977-1-4117524', '977-1-4117523', '977-1-5199097'],
  summitEmail: 'info@summitair.com.np',
};

export default config;
export const setUpSentry = () => Raven.config(config.sentry).install();
// export const setUpMixpanel = () => mixpanel.init(config.mixpanelKey);



// WEBPACK FOOTER //
// ./src/config/index.js